import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';

import { Title, Meta } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
@Component({
  selector: 'app-generalcosmetics',
  templateUrl: './generalcosmetics.component.html',
  styleUrls: ['./generalcosmetics.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class GeneralcosmeticsComponent {
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private seoService: SeoSocialShareService,private jsonLdService: JsonLdService,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){
    this.setSeoMeta();
    if (isPlatformBrowser(this.platformId)) {

    this.setSchema();
    this.setFaqSchemaData();
    this.setWebsiteSchema();
    // this.title.setTitle('Revolutionize Beauty Store Management with Medeil POS');

    // // Add meta tags dynamically
    // this.meta.addTag({ name: 'description', content: 'Elevate your beauty & cosmetics business with automated processes. Maximize ROI now!'  });
    // this.meta.addTag({ name: 'keywords', content: 'beauty software, beauty salon software, pos system for beauty salon, beauty salon pos, cosmetic shop software' });
  this.timezone=sessionStorage.getItem('timezone');
  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'Beauty & Cosmetic Store Software | Simplify Your Retail Operations',
  //     description: 'Run your beauty and cosmetic store effortlessly with Medeil\'s software. Manage inventory, sales, and customer loyalty programs with ease.',
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/beauty-cosmetic-store-software',
  //     keywords: 'Beauty store software, cosmetic store management, beauty retail software, cosmetic inventory software, beauty POS system.'
  //   };

  //   this.seoService.setData(seoData);
  // }
  // setWebsiteSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "WebSite",
  //     "name": "Medeil Beauty & Cosmetic Store Software",
  //     "url": "https://www.medeil.com",
  //     "description": "Medeil Beauty & Cosmetic Store Software helps you manage your beauty and cosmetic store efficiently. Track inventory, sales, and customer loyalty programs with ease.",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com",
  //       "logo": {
  //         "@type": "ImageObject",
  //         "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //       }
  //     }
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }

  // setSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "Medeil Beauty & Cosmetic Store Software",
  //     "url": "https://www.medeil.com/beauty-cosmetic-store-software",
  //     "description": "Run your beauty and cosmetic store effortlessly with Medeil's software. Manage inventory, sales, and customer loyalty programs with ease.",
  //     "applicationCategory": "BusinessApplication",
  //     "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "offers": {
  //       "@type": "Offer",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock",
  //       "url": "https://www.medeil.com/beauty-cosmetic-store-software",
  //       "keywords": "Beauty store software, cosmetic store management, beauty retail software, cosmetic inventory software, beauty POS system."
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "What features is your business software for beauty and cosmetics offering?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Specific features like inventory control, POS capability, appointment scheduling, loyalty programs, customer relationship management (CRM), and interaction with e-commerce platforms are among the aspects that customers frequently inquire about."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Is your beauty and cosmetic business software customizable to fit our specific needs?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Businesses may have unique requirements and workflows, so they want to know if the software can be tailored to their individual needs. This may include customizing fields, reports, workflows, and integrations."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "What is the implementation process like, and how long does it take to get up and running?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Implementing new software can be a significant undertaking for businesses, so they want to know about the implementation process, timeline, training options, and ongoing support available. They may also inquire about data migration, staff training, and technical support during and after the implementation process."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Is it possible for your beauty and cosmetics company software to work with our current tools and systems?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Companies might already be using other software programs like CRM systems, e-commerce platforms, or accountancy software. In order to minimize redundant data entry and improve operations, they would like to know if the business software for the beauty and cosmetics industry can be easily integrated with their current systems."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }



  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: $localize`:@@BEAUTY_COSMETIC_STORE.TITLE:Beauty & Cosmetic Store Software | Simplify Your Retail Operations`,
  //     description: $localize`:@@BEAUTY_COSMETIC_STORE.DESCRIPTION:Run your beauty and cosmetic store effortlessly with Medeil's software. Manage inventory, sales, and customer loyalty programs with ease.`,
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/beauty-cosmetic-store-software',
  //     keywords: $localize`:@@BEAUTY_COSMETIC_STORE.KEYWORDS:Beauty store software, cosmetic store management, beauty retail software, cosmetic inventory software, beauty POS system.`
  //   };

  //   this.seoService.setData(seoData);
  // }
  setSeoMeta() {
      const supportedLanguages = ['en', 'fr', 'es', 'pt'];
      let finalUrl = '';

      if (isPlatformBrowser(this.platformId)) {
        const origin = window.location.origin;
        const path = window.location.pathname;
        const parts = path.split('/');

        let lang = 'en'; // Default
        if (supportedLanguages.includes(parts[1])) {
          lang = parts[1];
        }

        const fullPath = path.replace(/^\/[a-z]{2}/, '');
        finalUrl = `${origin}/${lang}${fullPath}`;
      }

    const seoData = {
      title: $localize`:@@BEAUTY_COSMETIC_STORE.TITLE:Beauty Store Software | Simplify Retail Operations`,
      description: $localize`:@@BEAUTY_COSMETIC_STORE.DESCRIPTION:Run your beauty and cosmetic store effortlessly with Medeil's software. Manage inventory, sales, and customer loyalty programs with ease.`,
      image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
      url: finalUrl,
      keywords: $localize`:@@BEAUTY_COSMETIC_STORE.KEYWORDS:Beauty store software, cosmetic store management, beauty retail software, cosmetic inventory software, beauty POS system, beauty software, salon software, spa management software, beauty business software, appointment scheduling, salon POS, client management, MEDEIL beauty, spa software`
    };
    this.title.setTitle(seoData.title);
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }

  setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@BEAUTY_COSMETIC_STORE.SCHEMA_NAME:Medeil Beauty & Cosmetic Store Software`,
      "url": "https://www.medeil.com/beauty-cosmetic-store-software",
      "description": $localize`:@@BEAUTY_COSMETIC_STORE.SCHEMA_DESCRIPTION:Run your beauty and cosmetic store effortlessly with Medeil's software. Manage inventory, sales, and customer loyalty programs with ease.`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/beauty-cosmetic-store-software",
        "keywords": $localize`:@@BEAUTY_COSMETIC_STORE.SCHEMA_KEYWORDS:Beauty store software, cosmetic store management, beauty retail software, cosmetic inventory software, beauty POS system.`
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      }
    };

    this.jsonLdService.setData(schemaData);
  }

  setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@BEAUTY_COSMETIC_STORE.WEBSITE_NAME:Medeil Beauty & Cosmetic Store Software`,
      "url": "https://www.medeil.com",
      "description": $localize`:@@BEAUTY_COSMETIC_STORE.WEBSITE_DESCRIPTION:Medeil Beauty & Cosmetic Store Software helps you manage your beauty and cosmetic store efficiently. Track inventory, sales, and customer loyalty programs with ease.`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      }
    };

    this.jsonLdService.setData(schemaData);
  }

  setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ1_QUESTION:What features is your business software for beauty and cosmetics offering?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ1_ANSWER:Specific features like inventory control, POS capability, appointment scheduling, loyalty programs, customer relationship management (CRM), and interaction with e-commerce platforms are among the aspects that customers frequently inquire about.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ2_QUESTION:Is your beauty and cosmetic business software customizable to fit our specific needs?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ2_ANSWER:Businesses may have unique requirements and workflows, so they want to know if the software can be tailored to their individual needs. This may include customizing fields, reports, workflows, and integrations.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ3_QUESTION:What is the implementation process like, and how long does it take to get up and running?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ3_ANSWER:Implementing new software can be a significant undertaking for businesses, so they want to know about the implementation process, timeline, training options, and ongoing support available. They may also inquire about data migration, staff training, and technical support during and after the implementation process.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ4_QUESTION:Is it possible for your beauty and cosmetics company software to work with our current tools and systems?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@BEAUTY_COSMETIC_STORE.FAQ4_ANSWER:Companies might already be using other software programs like CRM systems, e-commerce platforms, or accountancy software. In order to minimize redundant data entry and improve operations, they would like to know if the business software for the beauty and cosmetics industry can be easily integrated with their current systems.`
          }
        }
      ]
    };

    this.addJsonLdToHead(faqSchema);
  }

  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.mainservice.generatecaptcha();
    this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
    }
  }
  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  })

  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }
}
